import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeItem, TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Observable, Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

export class ItemCategory{
    text:string;
    value:string;
    children:ItemCategory[];
}

@Component({
    selector: 'app-b2w-category',
    templateUrl: './b2w-category.component.html',
    styleUrl: './b2w-category.component.scss',
    standalone: false
})

export class B2wCategoryComponent  implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  sub1:Subscription;
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
  }
  
  selectedId:any;

  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data, public ThemeService:ThemeService,public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  onSelectedChange(evento){
  }

  onFilterChange(evento){

  }

  onClickLine(evento:TreeviewItem){
    if ( evento.value == 0){
      return;
    }
    if (evento.children!=null && evento.children.length>0 && evento.children[0].text == 'A Carregar'){
      let level = evento.parentCount;
      let id = evento.value;
      this.findCategories(level,id,evento);
    }
     else{
       if ( !evento.children ){
         this.dialogRef.close(evento.value);
       }
    }
    
  }


  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {

    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children:[]})];

    this.codecompany =155;// (this.data as UntypedFormGroup).get("CODECOMPANY").value;
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }
    
    this.buttonList.push({
      color:"warn",
      description:"Sair",
      action: ()=>{
          this.okFunction();
      }
    })

    this.findCategories(null);
    
  }

  findCategories(level?:number, id?:string, parentData?:TreeviewItem){
    this.spinner.show();
    let ob = {
      "entityName":"Mktpb2wcategory",
      "sql":`SELECT ID,CATEGORY,
            ${level == null? '(SELECT COUNT(*) FROM MKTPB2WCATEGORY A WHERE A.ID1 =X.ID AND A.ID2 IS NOT NULL AND A.ID3 IS NULL AND A.ID4 IS NULL AND A.ID5 IS NULL AND A.ID5 IS NULL AND A.CODECOMPANY=155) AS COUNTCHILD ' : ''}
            ${level == 1? '(SELECT COUNT(*) FROM MKTPB2WCATEGORY A WHERE A.ID2 =X.ID AND A.ID3 IS NOT NULL AND A.ID4 IS NULL AND A.ID5 IS NULL AND A.ID5 IS NULL AND A.CODECOMPANY=155) AS COUNTCHILD ' : ''}
            ${level == 2? '(SELECT COUNT(*) FROM MKTPB2WCATEGORY A WHERE A.ID3 =X.ID AND A.ID4 IS NOT NULL AND A.ID5 IS NULL AND A.CODECOMPANY=155) AS COUNTCHILD ' : ''}
            ${level == 3? '(SELECT COUNT(*) FROM MKTPB2WCATEGORY A WHERE A.ID4 =X.ID AND A.ID5 IS NOT NULL AND A.CODECOMPANY=155) AS COUNTCHILD ' : ''}
            ${level == 4? '(SELECT COUNT(*) FROM MKTPB2WCATEGORY A WHERE A.ID5 =X.ID AND A.CODECOMPANY=155) AS COUNTCHILD ' : ''}   

            FROM MKTPB2WCATEGORY X
            WHERE X.CODECOMPANY=${this.codecompany}
            ${level== null ? ' AND ID1 IS NOT NULL AND ID2 IS NULL AND ID3 IS NULL AND ID4 IS NULL AND ID5 IS NULL' : ''}
            ${level== 1 ? ` AND ID1 ='${id}' AND ID3 IS NULL`  : ''}
            ${level== 2 ? ` AND ID2 ='${id}' AND ID4 IS NULL`  : ''}
            ${level== 3 ? ` AND ID3 ='${id}' AND ID5 IS NULL`  : ''}
            ${level== 4 ? ` AND ID4 ='${id}' `  : ''}`
     
    }

   

    this.sub = this.http.post(ob,'JsonBrokerServices/findnative', true,true,false).subscribe(
        {
          next:(data)=>{
                  if( ObjectUtil.isNotEmpty(data['SQL'])){
                      this.transformData(data['SQL']);
                  }
                  // let index = parentData.children.findIndex(x=>x.value ==parent );
                  // parentData.children.splice(index,1);
                   if( parentData == null){
                     return;
                    }else{
                     
                     let index = parentData.children.findIndex(x=>x.value ==id );
                     
                     parentData.children.splice(index,1);
                   }
              },
          error: (error)=>{
            this.spinner.hide();
            throw error;
          },
          complete:()=>{
            this.spinner.hide();
          }
        }
    )
  
  }


  transformData(data):void{
    
    if ( data != null ){
        
      let resultado = data;
      let array:Object[] = resultado;
    
      for ( var item of array){
        
        let COUNTCHILD = item['COUNTCHILD'];
        let categoryData = JSON.parse(item['CATEGORY'])['categoryData'];

        let levels = Object.keys(categoryData).filter(key=>{

          if (key.startsWith('id')){
              if ( Number(key.replace('id',''))>0 ){
                  return true;
              }else{
                  return false;
              }
              
          }else{
              return false;
          }
        }).map(d=>(Number(d.replace('id','')))).sort((a,b)=>a>b?1:-1);

        let actualSize = Math.max(...levels);
        let nameActual = categoryData['name'+actualSize.toString()];
        
        let main:TreeItem = this.lista[0];
        
        for ( var level of levels){
            let cod = categoryData['id'+level];
            let name:string = categoryData['name'+level];
          
            let retorno:TreeItem  = this.findCode(cod,main.children);
            let item:TreeviewItem = new TreeviewItem({
              value:cod,
              text:cod + ' - '+ name + (COUNTCHILD>0?  ' ( ' + COUNTCHILD + ' )' : ''),
              checked: false,
              collapsed:true,
              children:[],
              parentCount:level
            });

            if ( COUNTCHILD > 0 ){
              item.children = [new TreeviewItem({text:'A Carregar',value:cod,checked:false,collapsed:true,children:[]})];
            }

            if ( retorno == null ){
              if ( main.children == null ){
                main.children = [item];
              }else{
                main.children.push(item);
              }
              main = item;  
            }else{
              main = retorno
            }
        } 
      }
    }
  }

  findCode( cod:string,itemArray:TreeItem[] ){
    if ( itemArray == null || itemArray.length == 0 ){
      return null;
    }
    
    for ( var i of itemArray){
      if ( i.value == cod ){
        return i;
      }
    }
    return null;   
  }

  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
    if ( this.sub1!= null ){ this.sub1.unsubscribe()};
  }

}
